module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0283e0a0fbda42b5aab1259c7d26c867.png";